import { CircleHelp, Wrench, Route, UserCheck, CalendarClock, Users, Mountain, TrendingUp, Globe } from "lucide-react";

export const FAQ_ICONS = { CircleHelp, Wrench, Route, UserCheck, CalendarClock, Users, Mountain, TrendingUp, Globe };
